// Base class for all views
import { Vue, Watch } from "vue-property-decorator";

import ErrorModule from "../store/modules/errorModule";
import LanguageModule from "../store/modules/languageModule";
import MatomoTracker from "@datapunt/matomo-tracker-js";
import { getModule } from "vuex-module-decorators";

const errorStore = getModule(ErrorModule);
const languageStore = getModule(LanguageModule);

export default abstract class ViewBase extends Vue {
  protected get language() {
    return languageStore.language;
  }

  protected get uri() {
    return process.env.VUE_APP_URI;
  }

  protected onError(errorMessage: string) {
    errorStore.set(errorMessage);
  }

  @Watch("title", { immediate: true }) private titleChanged() {
    if (this.title !== "") {
      const tracker = new MatomoTracker({
        urlBase: "https://moto.nationalmuseum.ch/",
        siteId: 23
      });

      const href = this.$route.fullPath;

      tracker.trackPageView({
        documentTitle: this.title,
        href: href
      });
    }
  }

  protected abstract get title(): string;
}
